export default __webpack_public_path__ + "static/media/catalogue.0efa1f00.svg";